'use strict';

var homeMenuButton = homeMenuButton || {};
var $ = jQuery;

/* INIT
 ----------------------------------------------------------------------------------------------------------------------*/
homeMenuButton.init = function () {
  homeMenuButton.move();
}

/* DOM READY
 ----------------------------------------------------------------------------------------------------------------------*/
$(homeMenuButton.init);

/* FUNCTIONS
 ----------------------------------------------------------------------------------------------------------------------*/
homeMenuButton.move = function () {

  // console.log("homeMenuButton");

  var menuButton = $('.block-content--homepage-menu-button');

  menuButton.appendTo(".block--menuitemsiconesfront");
  menuButton.addClass("d-inline-block");

};